import * as React from "react";
import { Text } from "@/components/atoms/Text";
import {
  FunctionalCard,
  FunctionalCardContent,
  FunctionalCardHeader,
} from "@/components/molecules/cards/FunctionalCard";
import { PopoverClose } from "@/components/molecules/Popover";
import XIcon from "@/icons/__generated__/X/X16";
import { cn } from "@/lib/utils";

type PriceLineItemTooltipCardProps = {
  title?: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  closeButton?: React.ReactNode;
};

const PriceLineItemTooltipCard = ({
  className,
  closeButton,
  content,
  title,
}: PriceLineItemTooltipCardProps) => {
  return (
    <FunctionalCard
      className={cn("tw-border-0 tw-w-full sm:tw-w-[225px]", className)}
    >
      {title && (
        <FunctionalCardHeader
          className="sm:tw-border-b-0"
          closeButton={
            closeButton || (
              <PopoverClose>
                <XIcon />
              </PopoverClose>
            )
          }
        >
          <Text typeface="body-1-m">{title}</Text>
        </FunctionalCardHeader>
      )}
      <FunctionalCardContent className="sm:tw-pt-8">
        <Text element="div" typeface="body-1" className="tw-text-gray-900">
          {content}
        </Text>
      </FunctionalCardContent>
    </FunctionalCard>
  );
};

PriceLineItemTooltipCard.displayName = "PriceLineItemTooltipCard";

export { PriceLineItemTooltipCard, type PriceLineItemTooltipCardProps };
